<div class="user-management-result">
  <div class="container-fluid">
    <div class="bg-white p-3 mt-2">
      <div class="row">
        <div class="col-md-5 col-sm-12">
          <h4>
            Modify Notification Type ({{notificationType?.notificationGroupName}})
            <!--<i class="fa fa-spinner fa-spin" *ngIf="isLoader"></i>-->
          </h4>
        </div>

      </div>
      <form #notificationForm="ngForm" novalidate>
        <div class="row ps-1 justify-content-center" *ngIf="notificationType">
          <div class="col-6">
            <div class="mb-2">
              <label for="name">Name</label>
              <input type="text"
                     id="name"
                     [(ngModel)]="notificationType.name"
                     name="name"
                     class="form-control"
                     required
                     #name="ngModel"
                     [ngClass]="{ 'is-invalid': name.invalid && name.touched }" />
              <div *ngIf="name.invalid && name.touched" class="invalid-feedback">
                Name is required.
              </div>
            </div>

            <div class="mb-2">
              <label for="description">Description</label>
              <input type="text"
                     id="description"
                     [(ngModel)]="notificationType.description"
                     name="description"
                     class="form-control"
                     required
                     #description="ngModel"
                     [ngClass]="{ 'is-invalid': description.invalid && description.touched }" />
              <div *ngIf="description.invalid && description.touched" class="invalid-feedback">
                Description is required.
              </div>
            </div>

            <div class="mb-2">
              <label for="subject">Subject</label>
              <input type="text"
                     id="subject"
                     [(ngModel)]="notificationType.defaultEmailSubject"
                     name="subject"
                     class="form-control"
                     required
                     #subject="ngModel"
                     [ngClass]="{ 'is-invalid': subject.invalid && subject.touched }" />
              <div *ngIf="subject.invalid && subject.touched" class="invalid-feedback">
                Subject is required.
              </div>
            </div>

            <div class="mb-2">
              <label for="emailMessage">Email Message</label>
              <textarea id="emailMessage"
                        [(ngModel)]="notificationType.defaultEmailBody"
                        name="emailMessage"
                        rows="5"
                        class="form-control"
                        required
                        #emailMessage="ngModel"
                        [ngClass]="{ 'is-invalid': emailMessage.invalid && emailMessage.touched }"></textarea>
              <div *ngIf="emailMessage.invalid && emailMessage.touched" class="invalid-feedback">
                Email message is required.
              </div>
            </div>

            <div class="mb-2">
              <label for="smsMessage">SMS Message</label>
              <textarea id="smsMessage"
                        [(ngModel)]="notificationType.defaultSMSText"
                        name="smsMessage"
                        rows="2"
                        class="form-control"
                        required
                        #smsMessage="ngModel"
                        [ngClass]="{ 'is-invalid': smsMessage.invalid && smsMessage.touched }"></textarea>
              <div *ngIf="smsMessage.invalid && smsMessage.touched" class="invalid-feedback">
                SMS message is required.
              </div>
            </div>

            <div class="mb-2">
              <label for="notificationId" class="col-sm-4 col-form-label">Tag Legend</label>

              <!--<div class="form-label" style="border: 1px solid lightgray">@SaleName  @DataType (i.e. X-ray, Scope Video, PDF Report)<br />@HIP@DataStatus (i.e. Approved/Denied))<br />@LOT@VetName<br />@ContactName@SaleAdmin<br />@Signature</div>-->
              <div class="form-control" style="border: 1px solid lightgray">
                <span [innerHTML]="notificationType?.tagLegend | safeHtml"></span>
              </div>

            </div>
            <div class="mb-2 text-end">
              <button class="btn btn-secondary" (click)="goToList()"><i class="fa fa-times"></i> Cancel</button>
              <button class="btn btn-primary ms-1" (click)="saveNotificationType()" [disabled]="notificationForm.invalid"><i class="fa fa-save"></i> Save</button>

            </div>
          </div>


        </div>
        </form>
    </div>
</div>
